
import React from 'react';

const Tick = (): JSX.Element => {
    return (
        <path fillRule="evenodd" clipRule="evenodd" d="M59 14.2537L20.1829 54L0 33.334L7.08414 26.0803L20.1829 39.4926L51.9159 7L59 14.2537Z" />
    );
};

export default Tick;
